import { Pipe, PipeTransform } from '@angular/core';
import { Workspace, WorkspaceState } from '@workspaces/models/workspaces';

@Pipe({
  name: 'workspaceStatusClass',
  pure: true,
  standalone: true
})
export class WorkspaceStatusClassPipe implements PipeTransform {
  transform(workspace: Workspace | WorkspaceState): string {
    if (!workspace) {
      return 'unknown-chip';
    }
    if (typeof workspace === 'string') {
      return WorkspaceStatusClassPipe.workspaceNameMap(workspace);
    }
    if (workspace.is_deleted) {
      return 'deleted-chip';
    }
    if (workspace.is_archived) {
      return 'archived-chip';
    }
    if (!workspace.state) {
      return 'unknown-chip';
    }

    const normalizedStatus = workspace.state.toUpperCase();

    return WorkspaceStatusClassPipe.workspaceNameMap(normalizedStatus);
  }

  static workspaceNameMap(normalizedStatus?: string) {
    if (!normalizedStatus) {
      return 'unknown-chip';
    }

    switch (normalizedStatus) {
      //Named statuses
      case 'ACTIVE':
        return 'active-chip';
      case 'DRAFTING':
        return 'drafting-chip';
      case 'IN_REVIEW':
        return 'review-chip';
      case 'APPROVED':
        return 'approved-chip';
      case 'FINISHED':
        return 'finished-chip';

      //Unknown
      default:
        return 'unknown-chip';
    }
  }
}
